(() => {
  const states = new Map();

  const CONFIGS = [
    { sel: ".hf-card",        price: ".hf-price-wrap",         add: "[data-hf-add]",     btns: ".hf-var-btn",       vid: "vid",       handle: el => el.dataset.productHandle },
    { sel: ".shop-card",      price: ".shop-card-price",       add: "[data-shop-add]",   btns: ".shop-var-btn",     vid: "vid",       handle: el => el.dataset.url?.split("/products/")[1]?.split("?")[0] },
    { sel: ".cc-card",        price: ".cc-price-wrap",         add: "[data-cc-add]",     btns: ".cc-var-btn",       vid: "vid",       handle: el => el.dataset.productHandle },
    { sel: ".otv-qs__module", price: ".otv-qs__product-price", add: "[data-qs-add-btn]", btns: ".otv-qs__size-btn", vid: "variantId", handle: el => el.dataset.productHandle, strainTiles: ".otv-qs__strain-tile" },
  ];

  function applyState(cfg, el, handle, v) {
    const price = el.querySelector(cfg.price);
    if (price) { price.setAttribute("data-product-handle", handle); price.setAttribute("data-variant-id", v); }
    const add = el.querySelector(cfg.add);
    if (add) add.dataset[cfg.vid] = v;
    el.querySelectorAll(cfg.btns).forEach(b => b.classList.toggle("is-active", b.dataset[cfg.vid] === v));
  }

  const render = () => window.Abra?.render?.();
  const restoreAll = () => states.forEach((s, el) => document.contains(el) && applyState(s.cfg, el, s.handle, s.vid));
  const attach = (btn, fn) => { if (btn.dataset.la) return; btn.dataset.la = "1"; btn.addEventListener("click", fn); };

  function init() {
    CONFIGS.forEach(cfg => {
      document.querySelectorAll(cfg.sel).forEach(el => {
        const handle = cfg.handle(el); if (!handle) return;
        const vid = el.querySelector(`${cfg.btns}.is-active`)?.dataset[cfg.vid];
        if (vid) { states.set(el, { cfg, handle, vid }); applyState(cfg, el, handle, vid); }

        el.querySelectorAll(cfg.btns).forEach(btn => attach(btn, function () {
          const v = this.dataset[cfg.vid], h = cfg.handle(el) || handle;
          states.set(el, { cfg, handle: h, vid: v });
          applyState(cfg, el, h, v);
          render(); setTimeout(restoreAll, 150);
        }));

        cfg.strainTiles && el.querySelectorAll(cfg.strainTiles).forEach(btn => attach(btn, () =>
          requestAnimationFrame(() => {
            const h = cfg.handle(el), v = el.querySelector(`${cfg.btns}.is-active`)?.dataset[cfg.vid];
            if (!h || !v) return;
            states.set(el, { cfg, handle: h, vid: v });
            applyState(cfg, el, h, v);
            render(); setTimeout(restoreAll, 150);
          })
        ));
      });
    });
  }

  document.addEventListener("click", e => {
    const btn = e.target.closest(".variant-button");
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    window.dispatchEvent(new CustomEvent("offers:variant:change", { detail: { variantId } }));
  });

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
  new MutationObserver(muts => { if (muts.some(m => m.type === "childList")) init(); })
    .observe(document.body, { childList: true, subtree: true });
})();
